export default __webpack_public_path__ + "static/media/about_fabric1.1015b7df.png";